/*
 * Copyright (c) 2026.
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden volgens de voorwaarden die zijn vastgelegd in een bijbehorende schriftelijke overeenkomst met Spin in het Web B.V.
 */

/**
 * Auteur: Jelmer Jellema - Spin in het Web B.V
 * Gegenereerd met Claude Code (AI), 10-09-2026
 *
 * Waar een feedbackuitslag vandaan komt. De drie feedbacksoorten — normfouten, bouwsuggesties en
 * simfeedback — beantwoorden elk de vraag "wat is hier nieuw", en het antwoord hangt af van de
 * herkomst van de uitslag. Die herkomst reist als argument door de aanroepketen mee, tot in de
 * closure van de normmatch-worker; zie `ontwerp-isnieuw.md`.
 */
import type {Tekenaanleiding} from '../app/model/opslag.service';

/**
 * - `berekend`: onze eigen uitslag op een gewijzigde stand — vergelijken met de vorige uitslag.
 * - `teruggehaald`: een undo, een redo of een replaystap. Er valt per definitie niets nieuws te
 *   melden: de gebruiker haalt een stand terug die hij al kende.
 * - `vanLeider`: de uitslag van de leider; zijn antwoord reist mee en wordt overgenomen.
 */
export type Feedbackherkomst = 'berekend' | 'teruggehaald' | 'vanLeider';

/**
 * De herkomst die bij een tekenaanleiding hoort. Het laden van een model levert `berekend` op en
 * geen eigen waarde: dat er dan niets nieuws is volgt uit de data — er is nog geen voorganger om
 * tegen af te zetten.
 */
export function herkomstVanAanleiding(aanleiding?: Tekenaanleiding): Feedbackherkomst {
    switch (aanleiding) {
        case 'herstel':
        case 'replaystap':
            return 'teruggehaald';
        default:
            return 'berekend';
    }
}
